// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__sVUiR","card":"Cards_card__1dOCT","infected":"Cards_infected__3-YVT","recovered":"Cards_recovered__31a8A","deaths":"Cards_deaths__3FBSg"};